const navLinks = [
  { label: 'Início', href: '#hero' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Portfólio', href: '#portfolio' },
  { label: 'Contato', href: '#contato' },
];

export default function Footer() {
  const handleNav = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#301531] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Col 1 */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/4db97c909d754362143458713f99c024.png"
              alt="INTRÊ Arquitetura"
              className="h-16 w-auto object-contain mb-5"
            />
            <p className="font-montserrat text-[#D6C4D6] text-sm leading-relaxed max-w-xs">
              Projetos de interiores com estratégia, estética e funcionalidade. Transformamos apartamentos em São Paulo com planejamento de alto padrão.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="https://instagram.com/intrearquitetura" target="_blank" rel="nofollow noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#D6C4D6]/30 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-white text-lg" />
              </a>
              <a href="https://wa.me/5511930672567" target="_blank" rel="nofollow noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#D6C4D6]/30 transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-white text-lg" />
              </a>
            </div>
          </div>

          {/* Col 2 */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h4 className="font-montserrat font-bold text-white text-sm uppercase tracking-widest mb-6">
              <a id="navegacao">Navegação</a>
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                    className="font-montserrat text-[#D6C4D6] text-sm hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h4 className="font-montserrat font-bold text-white text-sm uppercase tracking-widest mb-6">
              <a id="contato-footer">Contato</a>
            </h4>
            <div className="space-y-4">
              <a href="tel:+5511930672567" className="flex items-center gap-3 group cursor-pointer justify-center md:justify-start">
                <i className="ri-phone-line text-[#D6C4D6] text-base" />
                <span className="font-montserrat text-[#D6C4D6] text-sm group-hover:text-white transition-colors">(11) 93067-2567</span>
              </a>
              <a href="https://instagram.com/intrearquitetura" target="_blank" rel="nofollow noreferrer" className="flex items-center gap-3 group cursor-pointer justify-center md:justify-start">
                <i className="ri-instagram-line text-[#D6C4D6] text-base" />
                <span className="font-montserrat text-[#D6C4D6] text-sm group-hover:text-white transition-colors">@intrearquitetura</span>
              </a>
              <div className="flex items-center gap-3 justify-center md:justify-start">
                <i className="ri-map-pin-line text-[#D6C4D6] text-base" />
                <span className="font-montserrat text-[#D6C4D6] text-sm">São Paulo, SP</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#D6C4D6]/20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col items-center sm:flex-row sm:justify-between gap-3 text-center">
          <span className="font-montserrat text-[#D6C4D6] text-xs">
            © {new Date().getFullYear()} INTRÊ Arquitetura. Todos os direitos reservados.
          </span>
          <a
            href="https://startdigital1.com.br"
            target="_blank"
            rel="nofollow noreferrer"
            className="font-montserrat text-white text-xs font-medium hover:text-[#D6C4D6] transition-colors cursor-pointer"
          >
            Desenvolvido por Start Digital
          </a>
        </div>
      </div>
    </footer>
  );
}
